import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancer-patient',
  templateUrl: './cancer-patient.component.html',
  styleUrls: ['./cancer-patient.component.css']
})
export class CancerPatientComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}